import React from "react";
import { Card, Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";


// ✅ Import images properly
import usdeIcon from "../images/USD.svg";
import susdeIcon from "../images/USD.svg";
import enaIcon from "../images/USD.svg";
import senaIcon from "../images/USD.svg";

const RewardBalance = () => {
  return (
    <div className="border-primary shadow border-1 border bg-dark text-light p-3 rounded-4">
      <h6 className="mb-3">Token Balances</h6>
      <Row>
        {/* USDe Card */}
        <Col md={2} className="mb-3">
          <Card className="bg-black text-light shadow-sm rounded-4 border border-secondary" >
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div className="d-flex align-items-center gap-2">
                  <img src={usdeIcon} alt="USDe" width={22} height={22} />
                  <span>Ethena Rewards</span>
                </div>
               
              </div>
              
              <div className="mt-4 d-flex justify-content-between align-items-center">
                <div className="fw-bold fs-5">$0</div>
                <div className="fw-bold fs-5">$0</div>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* sUSDe Card */}
        <Col md={2} className="mb-3">
          <Card className="bg-black text-light  shadow-sm rounded-4 border border-secondary" >
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div className="d-flex align-items-center gap-2">
                  <img src={susdeIcon} alt="sUSDe" width={22} height={22} />
                  <span>Ethereal Points</span>
                </div>
                <span  className="text-white medium">15%</span>
              </div>
             
              <div className="mt-4">
                <div className="d-flex justify-content-between align-items-center gap-1">
                <div className="fw-bold fs-5">$0</div>
                <div className="fw-bold fs-5">$0</div>
                </div>
                
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* ENA Card */}
        <Col md={2} className="mb-3">
          <Card className="bg-black text-light  shadow-sm rounded-4 border border-secondary" >
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div className="d-flex align-items-center gap-2">
                  <img src={enaIcon} alt="ENA" width={22} height={22} />
                  <span>Derive Points</span>
                </div>
                <a href="#" className="text-primary medium">Stake</a>
              </div>
              
              <div className="mt-4 d-flex justify-content-between align-items-center">
              <div className="fw-bold fs-5">$0</div>
                <div className="fw-bold fs-5">$0</div>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={2} className="mb-3">
          <Card className="bg-black text-light  shadow-sm rounded-4 border border-secondary" >
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div className="d-flex align-items-center gap-2">
                  <img src={enaIcon} alt="ENA" width={22} height={22} />
                  <span>Derive Points</span>
                </div>
                <a href="#" className="text-primary medium">Stake</a>
              </div>
              
              <div className="mt-4 d-flex justify-content-between align-items-center">
              <div className="fw-bold fs-5">$0</div>
                <div className="fw-bold fs-5">$0</div>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={2} className="mb-3">
          <Card className="bg-black text-light  shadow-sm rounded-4 border border-secondary" >
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div className="d-flex align-items-center gap-2">
                  <img src={enaIcon} alt="ENA" width={22} height={22} />
                  <span>Derive Points</span>
                </div>
                <a href="#" className="text-primary medium">Stake</a>
              </div>
              
              <div className="mt-4 d-flex justify-content-between align-items-center">
              <div className="fw-bold fs-5">$0</div>
                <div className="fw-bold fs-5">$0</div>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* sENA Card */}
        <Col md={2} className="mb-3">
          <Card className=" bg-black text-light  shadow-sm rounded-4 border border-secondary"  >
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center mb-2" >
                <div className="d-flex align-items-center gap-2">
                  <img src={senaIcon} alt="sENA" width={22} height={22} />
                  <span>sENA</span>
                  <div className="mt-2 d-flex align-items-center gap-2">
                <span className="badge bg-secondary">40x</span>
                <span className="badge bg-secondary">2x</span>
              </div>
                </div>
                <a href="#" className="text-primary medium">Lock</a>
              </div>
            
              <div className="mt-4 d-flex justify-content-between align-items-center">                
                <div className="fw-bold fs-5">$0</div>
                <div className="fw-bold fs-5">$0</div>
              </div>
             
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <div className="p-3">
      <Card
        className="bg-black text-light border border-secondary rounded-4 p-3"
        style={{ boxShadow: "0 0 8px rgba(255,255,255,0.05)" }}
      >
        <div className="d-flex justify-content-between align-items-center px-3 py-2 border border-secondary rounded-4">
          {/* Left text */}
          <span className="fs-6">
            Stake ENA to begin earning boosted rewards on non-ENA positions
          </span>

          {/* Right glowing button */}
          <Button
            className="fw-bold"
            style={{
              background: "linear-gradient(90deg, #0f0f0f, #111)",
              border: "1px solid #2a2a2a",
              borderRadius: "12px",
              padding: "6px 18px",
              color: "white",
              fontSize: "0.85rem",
              boxShadow: "0px 0px 12px rgba(0, 136, 255, 0.6)",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
          >
            Stake ENA
          </Button>
        </div>
      </Card>
    </div>
      
    </div>
    
  );
};

export default RewardBalance;
